export const DEFAULT_SORT = '-starting_date';
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
